import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  HostListener,
  inject,
  ViewChild,
} from "@angular/core";
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from "@angular/forms";
import { ClevertapService } from "../../../service/clevertap.service";
import { LeadService } from "../../../service/lead.service";
import { ActivatedRoute, Router } from "@angular/router";
import { ToastService } from "../../../service/toast.service";
import { AsahiOtpModalComponent } from "../asahi-otp-modal/asahi-otp-modal.component";
import { CommonModule } from "@angular/common";
import { CalendarPickerComponent } from "../calendar-picker/calendar-picker.component";
import { TranslatePipe } from "@ngx-translate/core";

@Component({
  selector: "app-mobile-form-asahi",
  imports: [
    ReactiveFormsModule,
    TranslatePipe,
    AsahiOtpModalComponent,
    FormsModule,
    CommonModule,
    CalendarPickerComponent,
  ],
  templateUrl: "./mobile-form-asahi.component.html",
  styleUrl: "./mobile-form-asahi.component.scss",
})
export class MobileFormAsahiComponent {
  form!: FormGroup;
  fb = inject(FormBuilder);
  clevertapService = inject(ClevertapService);
  leadService = inject(LeadService);
  router = inject(Router);
  _actRoute = inject(ActivatedRoute);
  toastService = inject(ToastService);
  selectedOcuupation: string | null = null;
  selectedPhoneOption: string | null = null;
  selectedAction: string | null = null;
  activeDropdown: string | null = null;
  insuranceFor: string[] = [];
  showInsuranceForOthers = false;
  @ViewChild("phoneInput") phoneInput!: ElementRef;
  occupation = [
    "Office worker",
    "Engineer",
    "Teacher",
    "Driver",
    "Freelancer",
    "Others",
  ];
  traficSource: any;
  userDetails: any;
  userMobileNo: any;
  parallaxOffset = 0;
  selectedCountryCode: string = "+84";
  phoneVerified: boolean = false;
  verifiedPhoneNumber: string = "";
  showOtpModal = false;
  otpPhoneMasked = "";
  otpCountryCode = "84";
  otpMobileNo = "";
  otpLoading = false;
  otpErrorMsg = "";
  source!: any;
  selectedAge: string | null = null;
  age = [
    "16-19",
    "20-24",
    "25-29",
    "30-34",
    "35-39",
    "40-44",
    "45-49",
    "50-54",
    "55-59",
    "60-64",
    "65",
  ];
  showAgeDropdown = false;
  isLoading: boolean = false;

  // ---------- Constructor & Form Setup ----------
  constructor(
    private elementRef: ElementRef,
    private route: ActivatedRoute,
    private cdr: ChangeDetectorRef
  ) {
    this.form = this.fb.group({
      name: ["", Validators.required],
      phone: "",
      mobileNo: ["", [Validators.required, Validators.pattern(/^\d{10}$/)]],
      yearOfBirth: ["", Validators.required],
      gender: ["", Validators.required],
      averageMonthlyIncome: ["", Validators.required],
      occupation: ["", Validators.required],
      beneficiaryAgeRange: "",
      insuranceFor: [[], Validators.required],
      consent: [false, Validators.requiredTrue],
      source: ["Website"],
    });
  }

  // ngOnInit is a lifecycle hook in Angular
  ngOnInit() {
    this.route.queryParamMap.subscribe(params => {
      this.traficSource = params.get('traffic_source');
    });
    this._actRoute.url.subscribe((urlSegments) => {
      this.source = urlSegments.some((segment) => segment.path === "mobile");
      if (this.source) {
        this.form.get("source")?.setValue("App");
      }
    });
    this._actRoute.queryParams.subscribe((queryParams) => {
      const userId = queryParams["userId"];
      if (userId && this.source) {
        this.fetchUserDetails(userId, true);
      } else {
        this.form
          .get("mobileNo")
          ?.setValidators([
            Validators.required,
            Validators.pattern(/^\d{10}$/),
          ]);
        this.form.get("mobileNo")?.updateValueAndValidity();
        const name = this.form.get("name")?.value || "";
        const firstName = name.split(" ")[0] || "";
        const lastName = name.split(" ").slice(1).join(" ") || "";
        const email = "";
        const phoneNumber = this.form.get("mobileNo")?.value || "";
        const countryCode = this.selectedCountryCode.replace("+", "") || "84";
        const customerId = `${countryCode}-${phoneNumber}`;

        this.clevertapService.trackEvent("visited_lead_form", {
          product_type: "income_protection",
          traffic_source: this.traficSource,
          source: "App"
        });
      }
    });
  }
  /** To fetch user details */
  private fetchUserDetails(userId: string, triggerCleverTap?: boolean) {
    this.leadService.getUserDetails(userId).subscribe({
      next: (response: any) => {
        if (response.success) {
          this.userDetails = response.data;
          this.form.get("name")?.setValue(this.userDetails.name);
          if (this.userDetails.mobileNo) {
            this.form.get("phone")?.setValue("yes");
            this.form.get("mobileNo")?.setValue(this.userDetails.mobileNo);
            if (!this.form.get("mobileNo")?.value.startsWith("0")) {
              this.userMobileNo = "0" + this.form.get("mobileNo")?.value;
              this.form.get("mobileNo")?.patchValue(this.userMobileNo);
            }
          } else {
            this.form
              .get("mobileNo")
              ?.setValidators([
                Validators.required,
                Validators.pattern(/^\d{10}$/),
              ]);
            this.form.get("mobileNo")?.updateValueAndValidity();
          }
          if (triggerCleverTap) {
            const user = this.userDetails;
            const name = user.name || "";
            const firstName = name.split(" ")[0] || "";
            const lastName = name.split(" ").slice(1).join(" ") || "";
            const email = user.email || "";
            const phoneNumber = user.mobileNo || "";
            const countryCode = user.countryCode || this.selectedCountryCode.replace("+", "") || "84";
            const customerId = `${countryCode}-${phoneNumber}`;
            const uuid = user.uuid || '';
            this.clevertapService.setUserAttribute('Identity', customerId);
            this.clevertapService
              .setUserProfile(email, firstName, lastName, phoneNumber, name, uuid);
            this.clevertapService.trackEvent("visited_lead_form", {
              product_type: "income_protection",
              mobileNo: phoneNumber,
              countryCode,
              customer_id: customerId,
              first_name: firstName,
              last_name: lastName,
              email
            });
          }
        }
      },
      error: (error) => {
        this.form
          .get("mobileNo")
          ?.setValidators([
            Validators.required,
            Validators.pattern(/^\d{10}$/),
          ]);
        this.form.get("mobileNo")?.updateValueAndValidity();
      },
    });
  }

  /** Submits the lead form after validation and triggers phone verification */
  onSubmit() {
    if (this.form.invalid) {
      console.log("Form is invalid");
      this.form.markAllAsTouched();
      return;
    }

    if (!this.form.get("consent")?.value) {
      console.log("Consent is required");
      return;
    }
    if (
      this.form.get("insuranceFor")?.value.length === 1 &&
      this.form.get("insuranceFor")?.value?.[0] === "SELF"
    ) {
      this.form.get("beneficiaryAgeRange")?.reset();
    }
    this.onVerifyPhone();
    this.isLoading = true;
  }

  /** Initiates OTP verification for the entered phone number */
  onVerifyPhone() {
    const countryCode = this.selectedCountryCode.replace("+", "") || "84";
    const mobileNo =
      this.form.get("phone")?.value === "yes"
        ? this.userDetails?.mobileNo
        : this.form.get("mobileNo")?.value;
    if (!mobileNo || mobileNo.length < 8) {
      this.toastService.error(
        "Validation Error",
        "Please enter a valid phone number before requesting OTP."
      );
      return;
    }
    this.otpCountryCode = countryCode;
    this.otpMobileNo = mobileNo;
    this.otpLoading = true;
    this.otpErrorMsg = "";
    this.showOtpModal = true;
    const payload = { countryCode, mobileNo };
    console.log(payload);
    this.leadService.sendOtp(payload).subscribe({
      next: (response) => {
        this.otpPhoneMasked = mobileNo;
        this.showOtpModal = true;
        this.otpLoading = false;
      },
      error: (err) => {
        this.otpLoading = false;
        this.otpErrorMsg = 'Invalid OTP. Please try again.';
        this.toastService.showApiError(err, this.otpErrorMsg);
        console.error('OTP verification error:', err);
        // Restore scroll even on error (modal might close)
        document.body.style.overflow = 'auto';
      },
    }).add(() => {
      // Finally block - always executed
      this.otpLoading = false;
      // Ensure scroll is always restored
      document.body.style.overflow = 'auto';
    });
  }

  /** Allows user to edit the phone number after OTP modal is open */
  onOtpEdit() {
    this.showOtpModal = false;
    document.body.style.overflow = "auto";
    this.form.get("mobileNo")?.enable();
    setTimeout(() => {
      this.phoneInput.nativeElement.focus();
    }, 0);
    this.otpLoading = false;
    this.otpErrorMsg = "";
    this.phoneVerified = false;
    this.verifiedPhoneNumber = "";
  }

  /** Closes OTP modal and resets loading/error states */
  onOtpClosed() {
    this.showOtpModal = false;
    this.otpLoading = false;
    this.otpErrorMsg = '';
    document.body.style.overflow = 'auto';
  }

  /** Dispatches a global event to reset OTP modal */
  resetOtpModal() {
    const resetEvent = new CustomEvent("resetOtpModal");
    window.dispatchEvent(resetEvent);
  }

  /** Handles OTP verification success/failure */
  onOtpVerified(otp: any) {
    this.otpLoading = true;
    this.otpErrorMsg = "";
    const phone = this.otpMobileNo;
    const formatted = phone.replace(/^0/, "");
    const payload = {
      countryCode: this.otpCountryCode,
      mobileNo: formatted,
      otp: otp,
    };
    console.log(payload);
    this.leadService.verifyOtp(payload).subscribe({
      next: (response) => {
        this.phoneVerified = true;
        this.verifiedPhoneNumber = this.otpMobileNo;
        this.showOtpModal = false;
        document.body.style.overflow = 'auto';
        if (response) {
          const mobileNo =
            this.form.get("phone")?.value === "yes"
              ? this.userDetails?.mobileNo
              : this.form.get("mobileNo")?.value;
          const payload = {
            name: this.form?.get("name")?.value,
            mobileNo: mobileNo,
            yearOfBirth: this.form?.get("yearOfBirth")?.value,
            countryCode: this.otpCountryCode,
            type: "INCOME_PROTECTION_INSURANCE",
            source: this.form.get("source")?.value,
            gender: this.form.get("gender")?.value,
            averageMonthlyIncome: this.form.get("averageMonthlyIncome")?.value,
            occupation: this.form.get("occupation")?.value,
            insuranceFor: this.form.get("insuranceFor")?.value,
            beneficiaryAgeRange: this.form.get("beneficiaryAgeRange")?.value || "",
          };
          this.leadService.submitLead(payload).subscribe({
            next: (response) => {
              console.log(response);
              this.isLoading = false;
              const user = this.userDetails;
              const name = user?.name || payload.name || "";
              const firstName = name.split(" ")[0] || "";
              const lastName = name.split(" ").slice(1).join(" ") || "";
              const email = user?.email || "";
              const phoneNumber = user?.mobileNo || payload.mobileNo || "";
              const countryCode = user?.countryCode || payload.countryCode || "84";
              const customerId = `${countryCode}-${phoneNumber}`;
              const uuid = user?.uuid || "";
              this.clevertapService.setUserProfile(
                email,
                firstName,
                lastName,
                phoneNumber,
                name,
                uuid
              );
              this.clevertapService.trackEvent("submit_lead_form", {
                product_type: "income_protection",
                mobileNo: phoneNumber,
                country_code: countryCode,
                customer_id: customerId,
                first_name: firstName,
                last_name: lastName,
                email,
              });
              const currentLang = this.router.url.split("/")[1];
              const source = this.route.snapshot.queryParamMap.get("source") || "";
              const userId = this.route.snapshot.queryParamMap.get("userId") || "";

              this.router
                .navigate(
                  [
                    `${currentLang}/income-protection-insurance`,
                    "mobile-success-page",
                  ],
                  {
                    queryParams: { source, userId },
                  }
                )
                .then(() => {
                  window.scrollTo(0, 0);
                });
              this.toastService.success(
                "Success",
                "Phone number verified successfully!"
              );
            },
            error: (error) => {
              console.error("Error submitting lead:", error);
              this.isLoading = false;
              this.toastService.error('Error', 'Failed to submit lead. Please try again.');
            }
          }).add(() => {
            this.isLoading = false;
            this.otpLoading = false;
          });
        }
        this.otpLoading = false;
        this.otpErrorMsg = "";
        this.resetOtpModal();
        this.form.reset();
        this.form.get("insuranceFor")?.setValue([]);
        this.form.get("yearOfBirth")?.setValue("");

      },
      error: (err) => {
        this.otpLoading = false;
        this.otpErrorMsg =
          err.error?.message || "OTP verification failed. Please try again.";
        console.error("OTP verification error:", err);
      },
    }).add(() => {
      this.otpLoading = false;
    });
  }
  /** Sends Zalo OTP */
  onOtpZaloVerify() {
    this.otpLoading = true;
    this.otpErrorMsg = "";
    const phone = this.otpMobileNo;
    const formatted = phone.replace(/^0/, "");
    const payload = { countryCode: this.otpCountryCode, mobileNo: formatted };
    console.log(payload);
    this.leadService.sendZaloOtp(payload).subscribe({
      next: (response: any) => {
        this.otpLoading = false;
        this.toastService.showApiSuccess(
          response,
          "Zalo OTP sent successfully!"
        );
      },
      error: (err: any) => {
        this.otpLoading = false;
        this.otpErrorMsg = "Failed to send Zalo OTP. Please try again.";
        this.toastService.showApiError(err, this.otpErrorMsg);
        console.error("Zalo OTP send error:", err);
      },
    });
  }

  /** Placeholder for Call OTP verification (not implemented yet) */
  onOtpCallVerify() {
    this.otpLoading = false;
    this.toastService.info("Info", "Call verification is not implemented yet.");
  }
  /** Updates the number */
  formatPhone(event: any) {
    let input = event.target.value.replace(/\D/g, "").substring(0, 10);
    const area = input.substring(0, 3);
    const middle = input.substring(3, 6);
    const last = input.substring(6, 10);

    if (input.length > 6) {
      event.target.value = `(${area}) ${middle}-${last}`;
    } else if (input.length > 3) {
      event.target.value = `(${area}) ${middle}`;
    } else if (input.length > 0) {
      event.target.value = `(${area}`;
    }
    this.form.get("mobileNo")?.setValue(input);

    if (!input.startsWith("0")) {
      this.form.get("mobileNo")?.setErrors({ invalidPhone: true });
    }
    this.cdr.detectChanges();
  }

  /** Updates the phone number */
  getMaskedPhone(phone: string): string {
    if (!phone) return "";
    return phone.slice(0, 3) + "XXXXXXX";
  }

  /** Updates the dropdown */
  toggleDropdown(name: string) {
    this.activeDropdown = this.activeDropdown === name ? null : name;
  }

  /** Updates the dropdown */
  closeDropdown() {
    this.activeDropdown = null;
  }

  /** Selects a occupation and updates the form */
  selectOcuupation(occupation: string) {
    this.selectedOcuupation = occupation;
    this.form.get("occupation")?.setValue(occupation);
  }
  /** Selects a showInsuranceForOthers and updates the form */
  toggleSelection(option: string) {
    if (this.insuranceFor.includes(option)) {
      this.insuranceFor = this.insuranceFor.filter((item) => item !== option);
    } else {
      this.insuranceFor.push(option);
    }
    this.form.get("insuranceFor")?.patchValue(this.insuranceFor);
    this.showInsuranceForOthers = this.insuranceFor.some((opt) =>
      ["FAMILY", "FRIENDS", "OTHERS"].includes(opt)
    );
    if (!this.showInsuranceForOthers) {
      this.selectedAge = null;
      this.form.get("beneficiaryAgeRange")?.reset();
    }
  }
  /** Selects a age and updates the form */
  selectAge(age: string) {
    this.selectedAge = age;
    this.form.get("beneficiaryAgeRange")?.setValue(age);
    this.showAgeDropdown = false;
    if (this.showAgeDropdown) this.showAgeDropdown = false;
  }
  /** Updates the scroll */
  @HostListener("window:scroll", [])
  onWindowScroll() {
    this.parallaxOffset = window.scrollY * 0.4;
  }
  @HostListener("document:click", ["$event"])
  onClickOutside(event: Event) {
    const target = event.target as HTMLElement;
    if (target.closest(".dropdown-container")) {
      return;
    }
    this.closeDropdown();
  }
  /** Sets insurance expiry date in the form */
  onDateSelected(selectedDate: string) {
    const selectedYear = Number(selectedDate);
    const currentYear = new Date().getFullYear();
    const control = this.form.get("yearOfBirth");

    if (selectedYear > currentYear) {
      control?.setErrors({ invalidYear: true });
      control?.markAsTouched();
    } else {
      control?.setValue(selectedYear);
      control?.markAsTouched();
      control?.setErrors(null);
    }
  }

  private getTrafficSource(): string {
    const userAgent = navigator.userAgent || "";
    if (window.webkit?.messageHandlers?.closeHandler) {
      return "ios_app";
    }
    if (window.AndroidInterface?.closeWebView) {
      return "android_app";
    }
    const referrer = document.referrer;
    if (referrer) {
      if (referrer.includes("google")) {
        return "google";
      } else if (referrer.includes("facebook")) {
        return "facebook";
      } else if (referrer.includes("instagram")) {
        return "instagram";
      } else if (referrer.includes("twitter") || referrer.includes("t.co")) {
        return "twitter";
      } else if (referrer.includes("linkedin")) {
        return "linkedin";
      } else if (referrer.includes("youtube")) {
        return "youtube";
      } else {
        return "web_referral";
      }
    }
    const urlParams = new URLSearchParams(window.location.search);
    const utmSource = urlParams.get("utm_source");
    if (utmSource) {
      return utmSource;
    }
    return "direct";
  }
}
